module.exports = __webpack_public_path__ + "img/dave.300065f.webp";